import Vue from 'vue'
import Page from '@/components/pdf-pages/proforma-ship-supplier'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateProformaShipSupplier = async ({ rfq2s, salesOrder, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :salesOrder="salesOrder" :rfq2s="rfq2s" :content="content"/>`,
      components: {
        'page': Page
      },
      data: () => ({
        salesOrder,
        rfq2s,
        content
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
